import { LanguageCode } from "../../../../i18n/language";

/**
 * Translation resources for the contact component.
 */
export interface ContactResourceTranslations {
    title: string;
}

/**
 * Overall contact translation resources structure.
 */
type ContactResource = {
    [language in LanguageCode]: ContactResourceTranslations;
};

export const contactResource: ContactResource = {
    nl: {
        title: 'Neem contact met mij op'
    },
    en: {
        title: 'Get in touch with me'
    }
};